module.exports = {

    // Version 1.
    v1: [
        // Website.
        {
            color_scheme: 'website',
            question: 'Is your agency happy with the look, features, and ease of use of your current website?',
            answers: [
                {
                    answer: 'No, my agency doesn\'t have a website currently.',
                    response: 'You\'re in the right place! We can build a custom website design for your agency and configure our Sales Tool Suite to help your agency save time and close more deals.',
                    recommends: [
                        {
                            solution: 'WEBSITE',
                            reason: 'Your agency doesn\'t currently have a website, which is the foundation of your online presence and is key to SEO.',
                        },
                    ],
                },
                {
                    answer: 'No, my agency has a website, but there\'s room for improvement in one or more of these areas.',
                    response: 'We understand! Our custom designed agency websites come complete with a Sales Tool Suite to help your agency save time and close more deals.',
                    recommends: [
                        {
                            solution: 'WEBSITE',
                            reason: 'Your agency has a website, but you feel there\'s room for improvement. We\'ll build an amazing website loaded with sales tools for your agency.'
                        },
                    ],
                },
                {
                    answer: 'Yes, my agency has a website and we have no complaints in these areas.',
                    response: 'Shucks! If you ever need help with a new agency website in the future, just let us know.',
                    recommends: [],
                    not_recommended: [
                        {
                            solution: 'WEBSITE',
                            reason: 'Your agency already has a website and is happy with it.',
                        },
                    ],
                },
            ],
        },
        // Reviews & Reputation Management.
        {
            color_scheme: 'rrm',
            question: 'Is your agency actively monitoring your online reviews and getting new online reviews every month?',
            answers: [
                {
                    answer: 'No, we\'re not active with online reviews.',
                    response: 'You\'re missing out! We can quickly implement a holistic online reputation management strategy for your agency.',
                    recommends: [
                        {
                            solution: 'RRM',
                            reason: 'Your agency isn\'t keeping up with your online reviews or generating new reviews every month. Your online reputation is key to SEO and building trust with potential customers.',
                        },
                    ],
                },
                {
                    answer: 'Yes, but we\'re not happy with the results or it takes up too much of our time.',
                    response: 'No problem! We can help your agency save time by quickly implementing a holistic online reputation management strategy for your agency.',
                    recommends: [
                        {
                            solution: 'RRM',
                            reason: 'Your agency needs help keeping up with your online reviews and generating reviews every month. Your online reputation is key to SEO and building trust with potential customers.',
                        },
                    ],
                },
                {
                    answer: 'Yes, and everything we\'re doing is working great.',
                    response: 'Great job! If you ever need help with your online reputation in the future, just let us know.',
                    recommends: [],
                    not_recommended: [
                        {
                            solution: 'RRM',
                            reason: 'Your agency has a holistic online reputation management strategy in place that\'s working well.',
                        }
                    ],
                },
            ],
        },
        // Local Listing Management.
        {
            color_scheme: 'llm',
            question: 'Does your agency want to be found by consumers in your local area?',
            answers: [
                {
                    answer: 'Yes, my agency wants to be found by local consumers.',
                    response: 'We thought you might! We can help more local consumers find your agency by managing your local business listings.',
                    recommends: [
                        {
                            solution: 'LLM',
                            reason: 'Your agency wants to be found online by local consumers. Local listings management is key to SEO and succeeding in being found online by local consumers.',
                        },
                    ],
                },
                {
                    answer: 'No, my agency does not do business locally.',
                    response: 'Okay. If your agency decides to do business locally in the future, just let us know.',
                    recommends: [],
                    not_recommended: [
                        {
                            solution: 'LLM',
                            reason: 'Local listings management isn\'t as important if you\'re not doing business locally.',
                        },
                    ],
                },
            ],
        },
        // Social Media Marketing.
        {
            color_scheme: 'smm',
            question: 'Is your agency active on social media networks like Facebook, LinkedIn, and Google My Business?',
            answers: [
                {
                    answer: 'No, my agency isn\'t active on social media.',
                    response: 'No matter the reason why you\'re not taking advantage of social media, we\'ll make it easy for you to build a following. Strengthen relationships and grow referrals with social media.',
                    recommends: [
                        {
                            solution: 'SMM',
                            reason: 'Your agency isn\'t active on social media. Engaging with your customers on social media helps strengthen relationships and grow referrals.',
                        },
                    ],
                },
                {
                    answer: 'Yes, my agency is active on social media, but we\'re not happy with the results, time involvement, or cost.',
                    response: 'We\'re here to help! Our social media marketing service makes it easy for your agency to build a following and connect with customers while saving you time and money.',
                    recommends: [
                        {
                            solution: 'SMM',
                            reason: 'Your agency is active on social media but needs help growing and managing your social media marketing strategy.',
                        },
                    ],
                },
                {
                    answer: 'Yes, my agency is active on social media and we\'re killing it.',
                    response: 'Awesome! If you ever need help with social media in the future, just let us know.',
                    recommends: [],
                    not_recommended: [
                        {
                            solution: 'SMM',
                            reason: 'Your agency is active on social media and you\'re happy with your current results.',
                        },
                    ],
                },
            ],
        },
        // Pay Per Click.
        {
            color_scheme: 'ppc',
            question: 'Does your agency use digital advertising platforms like Google Ads to expand your digital presence?',
            answers: [
                {
                    answer: 'No, my agency doesn\'t use digital advertising.',
                    response: 'Search Engine Marketing can improve your online visibility, increase engagement, boost brand awareness, and most importantly, encourage your online prospects to take action.',
                    recommends: [
                        {
                            solution: 'PPC',
                            reason: 'Your agency isn\'t active on digital advertising platforms. Encouraging online prospects to take action through digital advertising improves your online visibility, increases engagement, and boosts brand awareness.',
                        },
                    ],
                },
                {
                    answer: 'Yes, my agency uses digital advertising, but there\'s room for improvement.',
                    response: 'As an official Google Partner, you can trust the insurance marketing experts at BrightFire to improve your online visibility, increase engagement, boost brand awareness, and most importantly, encourage your online prospects to take action.',
                    recommends: [
                        {
                            solution: 'PPC',
                            reason: 'Your agency is active on digital advertising platforms but needs help improving results. Encouraging online prospects to take action through digital advertising improves your online visibility, increases engagement, and boosts brand awareness.',
                        },
                    ],
                },
                {
                    answer: 'Yes, my agency has a digital advertising strategy that is performing well.',
                    response: 'Great! If you ever need help with digital advertising in the future, just let us know.',
                    recommends: [],
                    not_recommended: [
                        {
                            solution: 'PPC',
                            reason: 'Your agency is happy with the performance of your digital advertising strategy.',
                        },
                    ],
                },
            ],
        },
    ],

    // Version 2.
    v2: [

    ],

};
